

























































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IProposal, IPageParams, ITableOptions, IUser } from '../../models';
import { Watch } from 'vue-property-decorator';
import { getUserFullName } from '@/helpers/functions';
import { DateTime } from 'luxon';
import { PROFILE_CONTENT } from '@/const';
import paginationMixin from '@/mixins/pagintation';
@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    DateTime,
    namespace: 'proposal',
  }),
  methods: {
    getUserFullName,
  },
  mixins: [paginationMixin],
})
export default class ProposalList extends Vue {
  @State('currentUser', { namespace: 'user' })
  currentUser: IUser;
  @Action('deleteEntities', { namespace: 'proposal' })
  deleteEntities: () => void;
  @Action('getEntities', { namespace: 'proposal' }) getEntities: () => void;
  @Action('updateEntity', { namespace: 'proposal' }) updateEntity: any;
  @Getter('entitiesSlice', { namespace: 'proposal' })
  entitiesSlice: IProposal[];
  @State('pageParams', { namespace: 'proposal' }) pageParams: IPageParams;
  @State('loading', { namespace: 'proposal' }) loading: boolean;
  selected = [];
  interval = null;
  expanded = [];
  headers = [
    { text: '#', value: 'id' },
    { text: 'Файлы', value: 'files', sortable: false },
    { text: 'Название', value: 'name' },
    { text: 'Контрагент', value: 'contractor.name', sortable: false },
    { text: 'Ответственный', value: 'responsible', sortable: false },
    { text: 'Дата создания', value: 'created_at' },
    { text: 'Дата изменения', value: 'updated_at' },
    { text: 'Статус', value: 'proposal_status', sortable: false },
    {
      text: 'Агент(ы) заказчика',
      value: 'representatives',
      sortable: false,
    },
    { text: 'Создатель', value: 'creator', sortable: false },
  ];
  filters = [
    {
      searchKey: 'id',
      label: 'Номер',
      component: 'v-text-field',
      itemText: 'name',
    },
    {
      searchKey: 'name',
      label: 'Название',
      component: 'v-text-field',
      itemText: 'name',
    },
    {
      searchKey: 'description',
      label: 'Описание',
      component: 'v-text-field',
      itemText: 'description',
    },
    {
      searchKey: 'contractor_id',
      label: 'Контрагент',
      url: '/contractor',
      immediately: true,
      multiple: true,
      component: 'v-autocomplete',
      itemText: 'name',
    },
    {
      searchKey: 'responsible_id',
      label: 'Ответственный',
      url: '/user',
      immediately: true,
      multiple: true,
      component: 'v-autocomplete',
      itemText: (item: IUser) => getUserFullName(item),
    },
    {
      searchKey: 'creator_id',
      label: 'Создатель',
      immediately: true,
      multiple: true,
      component: 'v-autocomplete',
      url: '/user',
      itemText: (item: IUser) => getUserFullName(item),
    },
    {
      searchKey: 'proposal_status_id',
      label: 'Статус',
      immediately: true,
      multiple: true,
      component: 'v-autocomplete',
      url: '/proposal_status',
      itemText: 'name',
    },
  ];
  modalPatch = {};
  get config() {
    return Object.keys(PROFILE_CONTENT).length
      ? PROFILE_CONTENT.Propsal.list
      : false;
  }
  get profileHeaders() {
    if (this.config && this.config.headers) {
      //@ts-ignore
      const values = this.config.headers.map(({ value }) => value);
      return this.headers.reduce((acc, item) => {
        if (values.includes(item.value))
          //@ts-ignore
          acc.push({
            ...item,
            //@ts-ignore
            ...this.config.headers.find(({ value }) => value === item.value),
          });
        //@ts-ignore
        return acc;
      }, []);
    } else return this.headers;
  }
  getReadStatus(item: IProposal) {
    if (this.currentUser && this.currentUser.id === item.responsible_id) {
      return !item.read;
    } else return false;
  }

  setModalPatchField(field: string, value: any) {
    Vue.set(this.modalPatch, field, value);
  }
  updateModalEntity() {
    this.updateEntity(this.modalPatch);
  }
}
